(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tv', {
            parent: 'entity',
            url: '/tv',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.tv.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tv/tvs.html',
                    controller: 'TvController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tv');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tv-detail', {
            parent: 'entity',
            url: '/tv/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.tv.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tv/tv-detail.html',
                    controller: 'TvDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tv');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tv', function($stateParams, Tv) {
                    return Tv.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tv',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tv-detail.edit', {
            parent: 'tv-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tv/tv-dialog.html',
                    controller: 'TvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tv', function(Tv) {
                            return Tv.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tv.new', {
            parent: 'tv',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tv/tv-dialog.html',
                    controller: 'TvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tv: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tv', null, { reload: 'tv' });
                }, function() {
                    $state.go('tv');
                });
            }]
        })
        .state('tv.edit', {
            parent: 'tv',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tv/tv-dialog.html',
                    controller: 'TvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tv', function(Tv) {
                            return Tv.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tv', null, { reload: 'tv' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tv.delete', {
            parent: 'tv',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tv/tv-delete-dialog.html',
                    controller: 'TvDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tv', function(Tv) {
                            return Tv.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tv', null, { reload: 'tv' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
